import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="lazy-frame"
// Sets a turbo-frame's src once it scrolls into view, so pages with many frames don't request them all at once.
// Use this instead of Turbo's loading="lazy": a lazy frame ignores src changes until its first load fully finishes,
// which can swallow a click on a link inside the frame (e.g. an Edit button) right after its content appears.
export default class extends Controller {
  static values = { src: String }

  connect() {
    if (this.element.src) return // Already loaded, e.g. restored from the Turbo cache.

    this.observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        this.observer.disconnect()
        this.element.src = this.srcValue
      }
    })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
  }
}
